

const GetFileName = (comment) => {
    let name = comment.split("File Uploaded: ")[1]
    if (name.includes(".") === false) {
        return false
    }
    return name
}

const toTitleCase = (_str) => {
    return _str.replace(/\w\S*/g, text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
}

export default {
    GetFileName,
    toTitleCase
}